import { render, staticRenderFns } from "./NgColorCircle.vue?vue&type=template&id=0eb4a4d1"
import script from "./NgColorCircle.vue?vue&type=script&lang=js"
export * from "./NgColorCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports